import React from 'react';
import {Link} from 'react-router-dom';
import API from '../../configAPI';
class BimFilter extends React.Component{

  
    constructor(props) {
        super(props);
        this.state = { 
            formats:[],
            format_slug:this.props.format_slug,
            loading : true

        };
    }


    componentDidMount(){
        this.getFormats();
        this.setState({
            format_slug:this.props.format_slug,
        });
    }

    

    getFormats = () =>{
        API.PRODUCTS(`formatsBim`)
        .then(resp =>{

            console.log(resp);

            this.setState({
                formats : resp.data.formats,
                loading : false
            });
        })
        .catch(err =>{
            console.log(err);
        });
    }
    
    render(){

        return (
            
        <div className="list-group">
            <li className="list-group-item secondary bg-black">BIM / CAD</li>
            {this.state.formats.map((format,index) =>(

            this.props.format_slug==""?
              <Link to={'/bim-format/'+format.slug} key={index} className="list-group-item d-flex justify-content-between align-items-center list-group-item-action item-menu">
              {format.name} <span className="badge "><img src={format.url_icon} width="15px"></img></span>
                </Link>
               :
               <Link to={'/bim-format/'+format.slug} key={index} className={`list-group-item d-flex justify-content-between align-items-center list-group-item-action item-menu ${this.props.format_slug === format.slug ? 'active': ''}`}>
               {format.name} <span className="badge "><img src={format.url_icon} width="15px"></img></span>
                </Link>
                
               
                
            ))}
                <br></br>
        </div>
    

        );
    }
 
  


}
export default BimFilter;